export const BelorussianSpeakingIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 1 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width={width} height={height} rx="12" fill="white" />
        <path
          d="M2.97 18V8.2H7.366C8.49533 8.2 9.36333 8.42867 9.97 8.886C10.5767 9.334 10.88 9.95 10.88 10.734C10.88 11.266 10.7587 11.714 10.516 12.078C10.2827 12.442 9.96533 12.722 9.564 12.918C9.16267 13.114 8.72867 13.212 8.262 13.212L8.514 12.792C9.074 12.792 9.56867 12.89 9.998 13.086C10.4273 13.282 10.768 13.5713 11.02 13.954C11.272 14.3273 11.398 14.794 11.398 15.354C11.398 16.194 11.0807 16.8473 10.446 17.314C9.82067 17.7713 8.88733 18 7.646 18H2.97ZM4.37 16.866H7.59C8.36467 16.866 8.95733 16.7353 9.368 16.474C9.77867 16.2127 9.984 15.802 9.984 15.242C9.984 14.6727 9.77867 14.2573 9.368 13.996C8.95733 13.7347 8.36467 13.604 7.59 13.604H4.244V12.47H7.24C7.94933 12.47 8.5 12.3393 8.892 12.078C9.284 11.8167 9.48 11.4247 9.48 10.902C9.48 10.3793 9.284 9.98733 8.892 9.726C8.5 9.46467 7.94933 9.334 7.24 9.334H4.37V16.866ZM15.2597 12.428H20.2997V13.618H15.2597V12.428ZM15.3857 16.782H21.0977V18H13.9857V8.2H20.9017V9.418H15.3857V16.782Z"
          fill="#696F79"
        />
      </svg>
    </div>
  );
};
